<script>
    import Header from "./Header.svelte";
	import WidgetKeyword from "./WidgetKeyword.svelte";
	import WidgetGraph from "./WidgetGraph.svelte";
	import WidgetUser from "./WidgetUser.svelte";
    import WidgetSummary from "./WidgetSummary.svelte";
    import WidgetTopTweets from "./WidgetTopTweets.svelte";
	
</script>

<div class="h-screen flex flex-col">
	<Header />

	<main class="flex-grow w-full bg-black flex p-10">
		<div class="flex flex-col w-1/6 flex-none">
			<WidgetKeyword />
			<WidgetSummary />
			<WidgetTopTweets />
			<WidgetUser />
		</div>
		<WidgetGraph />
	</main>
</div>

